import { appState } from './appState';
import { appendMessage } from './chat';
import { dom } from './dom';
import { t } from './i18n';
function buildDemoSequence() {
    return [
        {
            role: 'user',
            content: t('demo.step1User'),
            anonymizedContent: t('demo.step1Anonymized'),
            entityMaps: {
                EMAIL: { 'amanda@northXwind.com': '[EMAIL_1]' },
                PHONE_NUMBER: { '+1 415-555-0134': '[PHONE_NUMBER_1]' }
            },
            delayMs: 4200
        },
        {
            role: 'ai',
            content: t('demo.step1Ai'),
            entityMaps: {
                EMAIL: { 'amanda@northXwind.com': '[EMAIL_1]' },
                PHONE_NUMBER: { '+1 415-555-0134': '[PHONE_NUMBER_1]' }
            },
            delayMs: 3600
        },
        {
            role: 'user',
            content: t('demo.step2User'),
            anonymizedContent: t('demo.step2Anonymized'),
            entityMaps: {
                CREDIT_CARD: { '4111 1111 1111 1111': '[CREDIT_CARD_1]' }
            },
            delayMs: 3000
        },
        {
            role: 'ai',
            content: t('demo.step2Ai'),
            entityMaps: {
                CREDIT_CARD: { '4111 1111 1111 1111': '[CREDIT_CARD_1]' }
            },
            delayMs: 3600
        },
        {
            role: 'user',
            content: t('demo.step3User'),
            anonymizedContent: t('demo.step3Anonymized'),
            entityMaps: {
                USERNAME: { '@janedoe': '[USERNAME_1]' },
                IP_ADDRESS: { '192.168.1.44': '[IP_ADDRESS_1]' }
            },
            delayMs: 3000
        },
        {
            role: 'ai',
            content: t('demo.step3Ai'),
            entityMaps: {
                USERNAME: { '@janedoe': '[USERNAME_1]' },
                IP_ADDRESS: { '192.168.1.44': '[IP_ADDRESS_1]' }
            },
            delayMs: 3600
        }
    ];
}
const DEMO_RESTART_DELAY_MS = 21000;
export function startDemoLoop() {
    if (appState.demoActive) {
        return;
    }
    appState.demoActive = true;
    runDemoCycle();
}
export function stopDemoLoop() {
    if (!appState.demoActive) {
        return;
    }
    appState.demoActive = false;
    clearDemoTimeouts();
}
export function restartDemoLoop() {
    stopDemoLoop();
    startDemoLoop();
}
function runDemoCycle() {
    if (!appState.demoActive) {
        return;
    }
    clearDemoTimeouts();
    dom.chatHistory.innerHTML = '';
    let elapsed = 0;
    const demoSequence = buildDemoSequence();
    demoSequence.forEach((step) => {
        const stepStart = elapsed;
        elapsed += step.delayMs;
        if (step.role === 'ai') {
            const loadingDelay = Math.min(700, Math.max(250, Math.floor(step.delayMs * 0.35)));
            const loadingTimeout = window.setTimeout(() => {
                if (!appState.demoActive) {
                    return;
                }
                showDemoLoadingIndicator();
            }, stepStart + loadingDelay);
            appState.demoTimeouts.push(loadingTimeout);
        }
        const timeoutId = window.setTimeout(() => {
            if (!appState.demoActive) {
                return;
            }
            if (step.role === 'ai') {
                hideDemoLoadingIndicator();
            }
            const message = {
                id: crypto.randomUUID(),
                role: step.role,
                content: step.content,
                anonymizedContent: step.anonymizedContent,
                entityMaps: step.entityMaps,
                timestamp: new Date()
            };
            appendMessage(message);
        }, elapsed);
        appState.demoTimeouts.push(timeoutId);
    });
    const restartId = window.setTimeout(() => {
        if (!appState.demoActive) {
            return;
        }
        hideDemoLoadingIndicator();
        runDemoCycle();
    }, elapsed + DEMO_RESTART_DELAY_MS);
    appState.demoTimeouts.push(restartId);
}
function clearDemoTimeouts() {
    appState.demoTimeouts.forEach(timeoutId => window.clearTimeout(timeoutId));
    appState.demoTimeouts = [];
}
function buildDemoLoadingIndicator() {
    const loadingDiv = document.createElement('div');
    loadingDiv.id = 'demo-loading-indicator';
    loadingDiv.className = 'd-flex justify-content-start mb-3';
    loadingDiv.innerHTML = `
    <div class="message-bubble shadow-sm p-3 message-ai" style="min-width: 100px;">
      <div class="d-flex align-items-center gap-2">
        <div class="spinner-grow spinner-grow-sm text-primary" role="status" style="width: 0.5rem; height: 0.5rem; animation-duration: 1s;"></div>
        <div class="spinner-grow spinner-grow-sm text-primary" role="status" style="width: 0.5rem; height: 0.5rem; animation-duration: 1s; animation-delay: 0.2s;"></div>
        <div class="spinner-grow spinner-grow-sm text-primary" role="status" style="width: 0.5rem; height: 0.5rem; animation-duration: 1s; animation-delay: 0.4s;"></div>
      </div>
    </div>
  `;
    return loadingDiv;
}
function showDemoLoadingIndicator() {
    const existing = document.getElementById('demo-loading-indicator');
    existing?.remove();
    const indicator = buildDemoLoadingIndicator();
    dom.chatHistory.appendChild(indicator);
    const chatWindow = document.getElementById('chatWindow');
    if (chatWindow) {
        chatWindow.scrollTop = chatWindow.scrollHeight;
    }
}
function hideDemoLoadingIndicator() {
    const indicator = document.getElementById('demo-loading-indicator');
    indicator?.remove();
}
